<div class="min-h-screen bg-gray-50">
    <!-- Header -->
    <app-header-nav></app-header-nav>

    <header class="sticky top-0 z-50 border-b bg-white shadow-sm">
        <div class="flex items-center justify-between p-4">
            <div class="flex items-center gap-3">
                <button mat-icon-button (click)="onBack()">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                <div class="flex items-center gap-2">
                    <mat-icon class="text-indigo-600">business</mat-icon>
                    <span class="text-lg font-semibold">BarFlow</span>
                </div>
            </div>
            <div class="flex items-center gap-2">
                <div class="flex items-center gap-2 px-3 py-1 bg-blue-50 rounded-full border border-blue-200">
                    <mat-icon class="text-blue-600 text-sm">business</mat-icon>
                    <span class="text-sm text-blue-700">The Local Bar</span>
                </div>
            </div>
        </div>
    </header>

    <!-- Loading Spinner -->
    <div class="flex items-center justify-center h-screen" *ngIf="isLoading">
        <mat-spinner></mat-spinner>
    </div>

    <!-- Main Content -->
    <main class="p-6 space-y-6" *ngIf="!isLoading">
        <!-- Dashboard Header -->
        <div class="flex items-center justify-between">
            <div>
                <h1 class="text-3xl font-bold">Service Provider Dashboard</h1>
                <p class="text-gray-600">Manage your bar operations</p>
            </div>
            <div class="flex items-center gap-2 px-3 py-1 bg-green-50 rounded-full border border-green-200">
                <div class="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span class="text-sm text-green-700">Online</span>
            </div>
        </div>

        <!-- Quick Stats -->
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
            <mat-card>
                <mat-card-header class="flex flex-row items-center justify-between space-y-0 pb-2">
                    <mat-card-title class="text-sm">Today's Orders</mat-card-title>
                    <mat-icon class="text-gray-500">assignment</mat-icon>
                </mat-card-header>
                <mat-card-content>
                    <div class="text-2xl font-bold">{{ todaysOrders }}</div>
                    <p class="text-xs text-gray-600">+12% from yesterday</p>
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-header class="flex flex-row items-center justify-between space-y-0 pb-2">
                    <mat-card-title class="text-sm">Revenue</mat-card-title>
                    <mat-icon class="text-green-500">credit_card</mat-icon>
                </mat-card-header>
                <mat-card-content>
                    <div class="text-2xl font-bold text-green-500">${{ todaysRevenue }}</div>
                    <p class="text-xs text-gray-600">Today's total</p>
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-header class="flex flex-row items-center justify-between space-y-0 pb-2">
                    <mat-card-title class="text-sm">Active Staff</mat-card-title>
                    <mat-icon class="text-blue-500">people</mat-icon>
                </mat-card-header>
                <mat-card-content>
                    <div class="text-2xl font-bold text-blue-500">{{ activeStaffCount }}</div>
                    <p class="text-xs text-gray-600">Currently working</p>
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-header class="flex flex-row items-center justify-between space-y-0 pb-2">
                    <mat-card-title class="text-sm">Low Stock Items</mat-card-title>
                    <mat-icon class="text-orange-500">warning</mat-icon>
                </mat-card-header>
                <mat-card-content>
                    <div class="text-2xl font-bold text-orange-500">{{ lowStockCount}}</div>
                    <p class="text-xs text-gray-600">Need restocking</p>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- Main Navigation -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <!-- Inventory Management -->
            <mat-card class="hover:shadow-lg transition-all cursor-pointer border-2 hover:border-indigo-200"
                (click)="navigateToView('inventory')">
                <mat-card-header>
                    <mat-card-title class="flex items-center gap-3">
                        <div class="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center">
                            <mat-icon class="text-indigo-600">inventory</mat-icon>
                        </div>
                        Inventory Management
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p class="text-sm text-gray-600 mb-4">
                        Manage drinks, categories, stock levels, and pricing
                    </p>
                    <div class="flex items-center justify-between text-xs">
                        <span class="text-gray-600">{{ totalDrinks }} items in stock</span>
                        <span class="text-orange-500">{{ lowStockCount }} low stock alerts</span>
                    </div>
                </mat-card-content>
            </mat-card>

            <!-- Order Management -->
            <mat-card class="hover:shadow-lg transition-all cursor-pointer border-2 hover:border-green-200"
                (click)="navigateToView('orders')">
                <mat-card-header>
                    <mat-card-title class="flex items-center gap-3">
                        <div class="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                            <mat-icon class="text-green-600">receipt</mat-icon>
                        </div>
                        Order Management
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p class="text-sm text-gray-600 mb-4">
                        View and manage customer orders, track order status
                    </p>
                    <div class="flex items-center justify-between text-xs">
                        <span class="text-gray-600">{{ pendingOrdersCount }} pending orders</span>
                        <span class="text-green-500">{{ completedOrdersToday }} completed today</span>
                    </div>
                </mat-card-content>
            </mat-card>

            <!-- Payment Processing -->
            <mat-card class="hover:shadow-lg transition-all cursor-pointer border-2 hover:border-purple-200"
                (click)="navigateToView('payments')">
                <mat-card-header>
                    <mat-card-title class="flex items-center gap-3">
                        <div class="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                            <mat-icon class="text-purple-600">payment</mat-icon>
                        </div>
                        Payment Processing
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p class="text-sm text-gray-600 mb-4">
                        Handle payments, refunds, and transaction history
                    </p>
                    <div class="flex items-center justify-between text-xs">
                        <span class="text-gray-600">${{ todaysPayments }} today</span>
                        <span class="text-purple-500">{{ todaysTransactions }} transactions</span>
                    </div>
                </mat-card-content>
            </mat-card>

            <!-- Staff Management -->
            <mat-card class="hover:shadow-lg transition-all cursor-pointer border-2 hover:border-blue-200"
                (click)="navigateToView('staff')">
                <mat-card-header>
                    <mat-card-title class="flex items-center gap-3">
                        <div class="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                            <mat-icon class="text-blue-600">people</mat-icon>
                        </div>
                        Staff Management
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p class="text-sm text-gray-600 mb-4">
                        Manage employees, schedules, and permissions
                    </p>
                    <div class="flex items-center justify-between text-xs">
                        <span class="text-gray-600">{{ totalStaff }} total staff</span>
                        <span class="text-blue-500">{{ activeStaffCount }} currently active</span>
                    </div>
                </mat-card-content>
            </mat-card>

            <!-- QR Code Management -->
            <mat-card class="hover:shadow-lg transition-all cursor-pointer border-2 hover:border-red-200"
                (click)="navigateToView('qr-codes')">
                <mat-card-header>
                    <mat-card-title class="flex items-center gap-3">
                        <div class="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
                            <mat-icon class="text-red-600">qr_code</mat-icon>
                        </div>
                        QR Code Management
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p class="text-sm text-gray-600 mb-4">
                        Generate and manage table QR codes for customer orders
                    </p>
                    <div class="flex items-center justify-between text-xs">
                        <span class="text-gray-600">{{ totalQrCodes }} QR codes</span>
                        <span class="text-red-500">{{ todaysQrScans }} scans today</span>
                    </div>
                </mat-card-content>
            </mat-card>

            <!-- Customer Chats -->
            <mat-card class="hover:shadow-lg transition-all cursor-pointer border-2 hover:border-pink-200"
                (click)="navigateToView('chat')">
                <mat-card-header>
                    <mat-card-title class="flex items-center gap-3">
                        <div class="w-12 h-12 bg-pink-100 rounded-lg flex items-center justify-center">
                            <mat-icon class="text-pink-600">chat</mat-icon>
                        </div>
                        Customer Chats
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p class="text-sm text-gray-600 mb-4">
                        Reply to messages from customers in real time
                    </p>
                    <div class="flex items-center justify-between text-xs">
                        <span class="text-gray-600">Live chat</span>
                        <span class="text-pink-500">Open inbox</span>
                    </div>
                </mat-card-content>
            </mat-card>

            <!-- Analytics & Reports -->
            <mat-card class="hover:shadow-lg transition-all cursor-pointer border-2 hover:border-yellow-200"
                (click)="navigateToView('analytics')">
                <mat-card-header>
                    <mat-card-title class="flex items-center gap-3">
                        <div class="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
                            <mat-icon class="text-yellow-600">analytics</mat-icon>
                        </div>
                        Analytics & Reports
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p class="text-sm text-gray-600 mb-4">
                        View sales reports, trends, and business insights
                    </p>
                    <div class="flex items-center justify-between text-xs">
                        <span class="text-gray-600">Revenue up 15%</span>
                        <span class="text-yellow-500">vs last week</span>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- Recent Activity -->
        <mat-card>
            <mat-card-header>
                <mat-card-title>Recent Activity</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="space-y-3">
                    <div *ngFor="let activity of recentActivity"
                        class="flex items-center justify-between py-2 border-b last:border-b-0">
                        <div class="flex items-center gap-3">
                            <div class="w-2 h-2 rounded-full" [ngClass]="activity.colorClass"></div>
                            <div>
                                <p class="text-sm font-medium">{{ activity.title }}</p>
                                <p class="text-xs text-gray-600">{{ activity.description }}</p>
                            </div>
                        </div>
                        <span class="text-xs text-gray-500">{{ activity.time }}</span>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </main>

    <app-footer></app-footer>
</div>